import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Id, Identifiable, Milestone, Project } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  hasRetrievedMilestone: boolean;
  milestone: Identifiable<Milestone> & { project: Identifiable<Project> };
  retrieveMilestone(request: Boundaries["retrieveMilestone"]["request"]): void;
}

function useMilestoneRetrieval(milestoneId: Id): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isMilestoneRetrievalRequestPending(milestoneId),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isMilestoneRetrievalRequestSuccess(milestoneId),
    ),
    isRequestFailure: useSelector(() =>
      selector.isMilestoneRetrievalRequestFailure(milestoneId),
    ),
    hasRetrievedMilestone: useSelector(() =>
      selector.hasRetrievedMilestone(milestoneId),
    ),
    milestone: useSelector(() => selector.getMilestone(milestoneId)),
    retrieveMilestone: core.retrieveMilestone,
  };
}

export { useMilestoneRetrieval };
